import { useEffect, useRef, useState } from 'react'
import PersonIcon from '@/assets/property-icons/person.svg';
import PersonHouse from '@/assets/property-icons/person-ina-house-icon.svg'
import { useCreateContractContext, useOpeningElementsControllerContext, useUserLanguage } from '@/customHooks';
import { SquareButtonsCard } from '../molecules';
//import { useNavigate } from 'react-router';
//import { pathURL } from '@/components/constants/urls';
import { TenantSimpleListData } from '@/custom-types';
import { TenantSimpleSelectionList } from './TenantSimpleSelectionList';
import { ListFilterControls } from './ListFilterControls';
import { OrderDirectionOption, PageSizeOption, useGetTenantsForContractsQuery } from '@/graphql/generated';
import { Pagination } from '../molecules';
import { useMemo } from 'react';

const textsData = {
  en: {
    button1: 'Add New Tenant',
    button2: 'Owned By Me',
  },
  es: {
    button1: 'Agregar Inquilino',
    button2: 'Me pertenece',
  }
}

export const SelectContractTenantMenu = () => {
  const userLanguage = useUserLanguage();
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  const selectedTenantRef = useRef<TenantSimpleListData | null>(null)
  const [search, setSearch] = useState('')
  const [orderDirection, setOrderDirection] = useState<OrderDirectionOption>(OrderDirectionOption.Asc)
  const [currentPage, setCurrentPage] = useState(1)
  const pageSize = PageSizeOption.TwentyFive

  const { createTenantFormModalOpen } = useOpeningElementsControllerContext()
  //const navigate = useNavigate()

  const buttons = [
    { text: texts.button1, icon: PersonHouse },
    { text: texts.button2, icon: PersonIcon },
  ];

  const { setTenant, setButtonDisabled, setButtonEnabled } = useCreateContractContext()

  const onButtonActionHandle = (value: number | null) => {
    switch (value) {
      case null:
        return

      case 0:
        createTenantFormModalOpen()
        //navigate(`/${pathURL.USER}/${pathURL.TENANT}/${pathURL.CREATE}`)
        break

      case 1:
        alert('Este boton está momentanemanete desabilitado')
        break

      default:
        throw new Error('On button action option is invalid [SelectContractTenantMenu]')
    }
  }

  useEffect(() => {
    if (!selectedTenantRef.current) return
    setButtonEnabled()
  }, [selectedTenantRef])

  useEffect(() => {
    setButtonDisabled()
    return () => {
      setTenant(selectedTenantRef.current)
    }
  }, [])

  useEffect(() => {
    setCurrentPage(1)
  }, [search, orderDirection])

  const variables = useMemo(() => ({
    input: {
      search: search || undefined,
      orderDirection,
      page: currentPage.toString(),
      pageSize,
    }
  }), [orderDirection, search, currentPage, pageSize])

  const { data } = useGetTenantsForContractsQuery({
    variables: variables as any,
    fetchPolicy: 'network-only'
  })

  const currentDataCount = data?.tenants?.items?.length || 0
  const totalPages = data?.tenants?.pagination?.totalPages || 1

  return (
    <div className="flex flex-col items-center w-full gap-4">
      <ListFilterControls
        search={search}
        onSearchChange={setSearch}
        orderDirection={orderDirection}
        onOrderChange={setOrderDirection}
      />

      <TenantSimpleSelectionList 
        selected={(tenant) => selectedTenantRef.current = tenant}
        search={search}
        orderDirection={orderDirection}
        currentPage={currentPage}
        pageSize={pageSize}
      />

      {currentDataCount > 0 && (
        <Pagination
          currentPage={currentPage}
          onPageChange={setCurrentPage}
          currentDataCount={currentDataCount}
          pageSize={pageSize}
          totalPages={totalPages}
        />
      )}

      <div className="mt-8">
        <SquareButtonsCard
          buttons={buttons}
          onSelected={onButtonActionHandle}
        />
      </div>
    </div>
  );
};
